import { useEffect } from "react";
import styles from "./InfoCard.module.css";
import TrendUp from "./Icons/TrendUp.svg";
import TrendFlat from "./Icons/TrendFlat.svg";
import TrendDown from "./Icons/TrendDown.svg";

import classNames from "classnames";
import { useTranslation } from "react-i18next";

export const InfoCard = ({
  header,
  icon,
  people,
  trend,
  trendLast,
  percent,
  percentDate,
  date,
  background,
  onClick,
}) => {
  useEffect(() => {
    // console.log("InfoCard icon prop:", icon);
  }, [icon]);

  const { t, i18n } = useTranslation();

  return (
    <div
      onClick={() => onClick()}
      className={classNames(
        styles.card,
        (background == "243746" || "415364") && styles.background1,
        background == "91B6BB" && styles.background2,
        background == "ADB7C0" && styles.background3,
        background == "9E703C" && styles.background3
      )}
      style={{ backgroundColor: "#" + background }}
    >
      <div className={styles.backgroundCircle}></div>
      <div className={styles.header}>
        <div className={styles.icon}>
          <img src={icon} alt={"Logo"} />
        </div>
        <div>{t(header)}</div>
        <div className={styles.imgContainer}>
          <div className={trendLast ? styles.trendFirst : styles.trend}>
            <img
              src={
                trend == "up"
                  ? TrendUp
                  : trend == "same"
                  ? TrendFlat
                  : trend == "down"
                  ? TrendDown
                  : ""
              }
              alt={`trend ${trend}`}
            />
          </div>
          {trendLast && (
            <div className={styles.firstText}>{t("Last Major")}</div>
          )}
        </div>
      </div>
      <div className={styles.header}>
        <div className={styles.people}>{people}</div>

        {percent && (
          <div className={styles.percent}>
            <div>{percent}%</div>
            <div>{t("Since")}</div>
            <div>
              {new Date(percentDate).toLocaleDateString(i18n.language, {
                month: "short",
                year: "numeric",
              })}
            </div>
          </div>
        )}

        {trendLast && (
          <div className={styles.imgContainer}>
            <div className={styles.trendLast}>
              <img
                src={
                  trendLast == "up"
                    ? TrendUp
                    : trendLast == "same"
                    ? TrendFlat
                    : trendLast == "down"
                    ? TrendDown
                    : ""
                }
                alt={`trend ${trendLast}`}
              />
            </div>
            <div className={styles.lastText}>
              {t("Last")}{" "}
              {header
                ?.split(" ")
                .filter((word) => !/^\d/.test(word))
                .map((word) => word[0]?.toUpperCase())
                .join("")}
            </div>
          </div>
        )}
      </div>

      <div className={styles.date}>
        <div>
          {new Date(date).toLocaleDateString(i18n.language, {
            month: "long",
            year: "numeric",
          })}
        </div>
      </div>
    </div>
  );
};

InfoCard.propTypes = {};
